
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Rooms_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 44.15 33.89","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Rooms_svg__st0",attrs:{"d":"M11.62 9.15h11.21v1H11.62zM11.62 12.21h11.21v1H11.62zM11.62 15.26h11.21v1H11.62z"}}),_c('path',{staticClass:"Rooms_svg__st0",attrs:{"d":"M22.11.01L22.07 0 .11 7.79 0 7.83l.55 1.55L6.14 7.4v26.49H38V7.4l5.49 1.95.11.04.55-1.55L22.11.01zm-6.14 32.23H7.79V21.61h8.18v10.63zm20.39 0H17.2V21.61h19.16v10.63zm0-11.86h-8.39V6.32h-1.23v14.06H7.79V6.81l14.28-5.07 14.28 5.07v13.57z"}})])
          )
        }
      }
    